<script setup lang="ts">
import { useForwardPropsEmits, type CheckboxRootEmits } from "reka-ui";
import type { InputHTMLAttributes } from "vue";
import { useDelegatedProps, type ClassProps } from "../../lib/base-props";
import FormField, { type FormFieldProps } from "../form/FormField.vue";
import type { CheckboxProps } from "./Checkbox.vue";
import Checkbox from "./Checkbox.vue";

defineOptions({ inheritAttrs: true });

interface Props
	extends ClassProps,
		CheckboxProps,
		FormFieldProps,
		/* @vue-ignore */ Omit<InputHTMLAttributes, keyof CheckboxProps | keyof FormFieldProps> {}

const props = withDefaults(defineProps<Props>(), { color: "primary" });
const emit = defineEmits<CheckboxRootEmits>();

const delegatedProps = useDelegatedProps(props);
const forwarded = useForwardPropsEmits(delegatedProps, emit);
</script>

<template>
	<FormField
		:class="props.class"
		:label="props.label"
		labelPosition="left"
		:hint="props.hint"
		:errors="props.errors"
	>
		<Checkbox v-bind="{ ...forwarded, ...$attrs }" />
	</FormField>
</template>
